@let canConfigure =
  meFeature.contexts.selectors.currentUserCanConfigureApp.asSignal();
@let canSave = canSaveSg();
@let config = surveyConfigurationFeature.selectors.editedConfig.asSignal();
@let error = surveyConfigurationFeature.selectors.error.asSignal();
@let isLoading = surveyConfigurationFeature.selectors.isLoading.asSignal();
@let scenarioContext = meFeature.contexts.selectors.scenarioContext.asSignal();
@let title = titleSg();

@if (!canConfigure) {
  <div class="atn-space-survey-configuration__empty-state-container">
    <div class="atn-space-survey-configuration__empty-state-content">
      <atn-ds-empty-state
        type="no-data"
        title="You don't have access to this page"
        description="You don't have permission to configure this survey. Contact your administrator if you need access."
        layout="v"
      />
    </div>
  </div>
} @else if (!isLoading) {
  <atn-ds-page class="atn-space-survey-configuration">
    <atn-ds-widget
      class="atn-space-survey-configuration__widget"
      [title]="title"
    >
      <ng-container actions>
        <atn-ds-button
          [disabled]="!canSave"
          [loading]="isLoading"
          (click)="saveClickHandler()"
        >
          Save
        </atn-ds-button>
      </ng-container>

      @if (!scenarioContext) {
        <div class="atn-space-survey-configuration__state">
          <atn-ds-empty-state
            type="no-data"
            title="Survey configuration is not available."
            description="Select a valid scenario to view and edit survey configuration."
            layout="h"
          />
        </div>
      } @else if (error) {
        <div class="atn-space-survey-configuration__state">
          <atn-ds-empty-state
            type="error"
            title="Unable to load configuration options"
            [description]="
              error.message
                ? 'Our system is yelling at us: &quot;' +
                  error.message +
                  '&quot; Maybe just try refreshing the page?'
                : 'Try refreshing the page in a minute or two. If the problem persists, contact your administrator.'
            "
            layout="h"
          />
        </div>
      } @else {
        <div class="atn-space-survey-configuration__content">
          <atn-ds-section name="Survey Tools">
            <div class="atn-space-survey-configuration__tools-options">
              <atn-ds-checkbox
                [label]="allowUsersToUnlockRoomsDirectlyLabel"
                [disabled]="isLoading"
                [selected]="
                  config?.tools?.allowUsersToUnlockRoomsDirectly ?? false
                "
                (selectedChange)="
                  toolsChangedHandler({
                    allowUsersToUnlockRoomsDirectly: $event,
                  })
                "
              />
            </div>
          </atn-ds-section>

          <atn-ds-section
            name="Functional Usages & Functional Usage Calculation"
          >
            <div class="atn-space-survey-configuration__func-usage-options">
              <atn-ds-checkbox
                [label]="requireSponsoredAccountAssignmentsLabelSg()"
                [disabled]="isLoading"
                [selected]="
                  config?.functionalUsage
                    ?.requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages ??
                  false
                "
                (selectedChange)="
                  functionalUsageChangedHandler({
                    requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages:
                      $event,
                  })
                "
              />
              <atn-ds-checkbox
                [label]="requireFunctionalUsageAssignmentsLabelSg()"
                [disabled]="isLoading"
                [selected]="
                  config?.functionalUsage
                    ?.requireFunctionalUsageAssignmentsForSelectedAccounts ??
                  false
                "
                (selectedChange)="
                  functionalUsageChangedHandler({
                    requireFunctionalUsageAssignmentsForSelectedAccounts:
                      $event,
                  })
                "
              />
            </div>
          </atn-ds-section>
        </div>
      }
    </atn-ds-widget>
  </atn-ds-page>
} @else {
  <div class="atn-space-survey-configuration__loading-state">
    <atn-ds-loader
      type="page"
      message="Loading configuration..."
    />
  </div>
}
